export const SET_HEADER_DETAILS = "set_header_details";
export const setHeaderDetails = (response = {}) => {
  return (dispatch) => {
    dispatch({
      type: SET_HEADER_DETAILS,
      payload: response,
    });
  };
};
